// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import "./controllers"

// require('aos/dist/aos.css')

// Font Awesome
import { library, dom } from '@fortawesome/fontawesome-svg-core'
import { faMapMarkerAlt } from '@fortawesome/free-solid-svg-icons/faMapMarkerAlt'
import { faPhone } from '@fortawesome/free-solid-svg-icons/faPhone'
import { faEnvelope } from '@fortawesome/free-solid-svg-icons/faEnvelope'
import { faCheckCircle } from '@fortawesome/free-solid-svg-icons/faCheckCircle'
import { faBars } from '@fortawesome/free-solid-svg-icons/faBars'
import { faHeart } from '@fortawesome/free-solid-svg-icons/faHeart'
import { faChild } from '@fortawesome/free-solid-svg-icons/faChild'
import { faSun } from '@fortawesome/free-solid-svg-icons/faSun'

library.add(faMapMarkerAlt)
library.add(faPhone)
library.add(faEnvelope)
library.add(faCheckCircle)
library.add(faBars)
library.add(faHeart)
library.add(faChild)
library.add(faSun)

dom.watch()

// Move to
import MoveTo from 'moveto'
document.addEventListener('turbo:load', function(event) {
  const moveTo = new MoveTo()
  const triggers = document.getElementsByClassName('is-scroll')
  for (var trigger of triggers) {
    moveTo.registerTrigger(trigger)
  }
})

// keinaufwand
document.addEventListener('turbo:render', function() {
  _takashi.init_form();
});
